import { Coins } from "lucide-react";
import { useLang } from "../context/LangContext";
import { formatCoins } from "../lib/format";

const PRESETS = [10, 50, 100, 500, 1000];

export default function BetControl({ bet, setBet, max, disabled }) {
  const { t } = useLang();
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold tracking-wider uppercase text-amber-400/90">{t("betAmount")}</span>
        <span className="flex items-center gap-1 text-sm font-mono-num text-amber-200">
          <Coins size={14} /> {formatCoins(bet)}
        </span>
      </div>
      <div className="flex flex-wrap gap-2">
        {PRESETS.map((p) => (
          <button
            key={p}
            disabled={disabled}
            onClick={() => setBet(p)}
            data-testid={`bet-preset-${p}`}
            className={`rounded-lg px-3 py-1.5 text-sm font-bold border transition-colors disabled:opacity-40 ${
              bet === p
                ? "btn-gold border-transparent"
                : "border-amber-500/30 bg-black/30 text-amber-200 hover:border-amber-500/70"
            }`}
          >
            {p}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <button
          disabled={disabled}
          onClick={() => setBet(Math.max(10, Math.floor(bet / 2)))}
          className="rounded-lg border border-slate-600 px-3 py-1.5 text-sm font-bold text-slate-300 disabled:opacity-40"
          data-testid="bet-half"
        >
          ½
        </button>
        <input
          type="number"
          min={1}
          value={bet}
          disabled={disabled}
          onChange={(e) => setBet(Math.max(1, Number(e.target.value) || 0))}
          data-testid="bet-input"
          className="flex-1 rounded-lg border border-amber-500/30 bg-black/40 px-3 py-1.5 text-center font-mono-num text-amber-200 focus:outline-none focus:border-amber-500/80"
        />
        <button
          disabled={disabled}
          onClick={() => setBet(max ? Math.min(max, bet * 2) : bet * 2)}
          className="rounded-lg border border-slate-600 px-3 py-1.5 text-sm font-bold text-slate-300 disabled:opacity-40"
          data-testid="bet-double"
        >
          2×
        </button>
      </div>
    </div>
  );
}
